import { render } from "./Sidebar.vue?vue&type=template&id=72d175cf"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=72d175cf&lang=css"

import exportComponent from "/var/www/corfits.id/e-budgeting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__